module.exports = __webpack_public_path__ + "../../../static/img/c_im_21.32f8a40b.png";